module.exports = __webpack_public_path__ + "static/img/17059D_1_R_20201021_fit.6876bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17059D_1_R_20201021_fit.png
// module id = Sl3Z
// module chunks = 0